import { render, staticRenderFns } from "./ApartmentCharacteristicsBlock.vue?vue&type=template&id=c75328e2&scoped=true&"
import script from "./ApartmentCharacteristicsBlock.vue?vue&type=script&lang=js&"
export * from "./ApartmentCharacteristicsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ApartmentCharacteristicsBlock.vue?vue&type=style&index=0&id=c75328e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75328e2",
  null
  
)

export default component.exports